<template>
  <div class="mt-4">
    <div v-if="isLoading" class="text-center">
      <hr class="space space-sm">
      <loader size="128px"></loader>
      <p class="small muted pt-4">One moment...</p>
    </div>
    <div v-else-if="invoices && invoices.length">
      <div
        v-for="invoice in invoices"
        :key="invoice.id"
        class="d-flex mb-4"
      >
        <div class="flex-grow-1 pl-md-4">
          <p class="large regular mb-0">
            <a v-if="invoice.pdf" href="#" @click.prevent="download(invoice)">{{ invoice.number }}</a>
            <span v-else>{{ invoice.number }}</span>
          </p>
          <p class="mb-0">
            <span v-if="invoice.is_paid" class="small regular text-primary">
              <img src="/static/images/icons/invoice_status_paid.svg" />
              Paid
            </span>
            <span v-else class="small muted">
              <img src="/static/images/icons/invoice_status_unpaid.svg" />
              Not paid
            </span>
            <span class="muted">
              &middot;
            </span>
            <span class="regular" :class="{ muted: invoice.is_paid }">
              <template v-if="invoice.currency == 'gbp'">£</template>
              <template v-if="invoice.currency == 'usd'">$</template>
              <template v-if="invoice.currency == 'eur'">€</template>
              {{ invoice.amount | money }}
            </span>
          </p>
          <p class="small muted mb-0">{{ invoice.issued | moment("D MMMM YYYY") }}</p>
        </div>
      </div>
    </div>
    <div v-else class="text-center">
      <img src="/static/images/icons/invoices_empty.svg" alt="">
      <p class="regular pt-4">The list is empty</p>
      <p class="lh15 small">
        We haven't issued any invoices yet. As soon as we create one, you will get a notification on email.
      </p>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'dashboard-invoices',
  props: ['id'],
  data () {
    return {
      isLoading: true
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      project: state => state.projects.current,
      invoices: state => state.projects.invoices
    })
  },
  mounted () {
    window.scrollTo(0, 0)
    this.$store.dispatch('LOAD_PROJECT_INVOICES', this.id)
      .then((response) => {
        this.isLoading = false
      })
    if (!this.project || !this.project.id === this.id) {
      this.$store.dispatch('LOAD_PROJECT_BY_ID', this.id)
    } else {
      this.isLoading = this.invoices && this.invoices.length > 0
    }
  },
  methods: {
    download (invoice) {
      if (invoice.pdf) {
        window.open(invoice.pdf)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
